<template>
  <m-dialog ref="dlg" @save="save" :title="model && model.id ? 'Ubah Angkatan' : 'Tambah Angkatan'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <FormGenerator autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation :field= "schema" :model="model" :data="data"/>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import FormGenerator from "@/components/FormGenerator"
//@group Angkatan
export default {
  name: "angkatan-form",
  provide () {
    return { parentValidator: this.$validator }
  },
  $_veeValidate: {
    validator: "new"
  },
  components: {
    FormGenerator
  },

  data() {
    return {
      step: 1,
      defAngkatan: {
        nama: "",
        nomor: null ,
      },
      switch1: true,
      data: {},
      model: {},
      schema: [
        {
          grid: {md:6, lg: 6},
          component: "VTextField",
          model: "nama",
          properties: {
            name: "Angkatan",
            placeholder: "Isikan Nama",
            label: "Angkatan",
            clearable: true
          },
          validation: {
            dataVvName: "angkatan",
            dataVvAs: "Angkatan",
            vValidate: "required",
            errorMessages: "form.angkatan"
          }
        },
        {
          grid: {md:6, lg: 6},
          component: "VTextField",
          model: "nomor",
          properties: {
            name: "Nomor",
            placeholder: "Nomor",
            label: "Nomor",
            type: "number",
            min: 1
          },
          validation: {
            dataVvName: "nomor",
            dataVvAs: "Nomor",
            vValidate: "required",
            errorMessages: "form.nomor"
          }
        },
        {
          grid: {cols: 12, sm: 12, md: 12, lg: 12},
          component: "VSwitch",
          model: 'is_kuota',
          properties: {
            name: "setkuota",
            inset: true,
            label: "Atur Kuota"
          }
        },
        {
          grid: {cols: 12, sm: 6, md: 6, lg: 6},
          component: "VTextField",
          model: "kuota",
          properties: {
            label: "Kuota",
            name: "Kuota",
            placeholder: "Kuota",
            type: "number",
            min: 1
          },
           validation: {
            dataVvName: "kuota",
            dataVvAs: "Kuota"
          },
          conditional: {
            cond: false
          }
        }
      ]
    };
  },
  methods: {
    //@vuese
    //mengecek dan membuka dialog untuk tambah / edit angkatan
    //@args objek angkatan
    open(obj) {
      if (obj) {
        this.model = { ...obj };
      } else {
        this.model = { ...this.defAngkatan };
      }
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },

    //@vuese
    //menyimpan data angkatan
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("angkatan/form", {
              instansi_id: this.instansi_id,
              obj: this.model
            })
            .then(res => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  },
  watch: {
    'model.is_kuota'(v){
      let x  = this.schema.findIndex(e => e.model == "kuota");
      this.schema[x].conditional.cond = v
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
